(function(){
  const LOCALE = 'es-MX', CURRENCY = 'MXN';

  function fmt(cents){
    try { return (cents/100).toLocaleString(LOCALE,{style:'currency',currency:CURRENCY}); }
    catch(e){ return '$'+(cents/100).toFixed(2)+' '+CURRENCY; }
  }

  async function getTotal(){
    try{
      const r = await fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}});
      if(!r.ok) throw new Error('cart fetch failed');
      const cart = await r.json();
      return Number(cart.total_price)||0;
    }catch(e){
      console.warn('[px-ship] fetch error', e);
      return null;
    }
  }

  function paint(node, total){
    const goal = Number(node?.dataset?.goal || 129900);
    if(!node || isNaN(goal)) return;

    const fill = node.querySelector('#px-ship-fill');
    const note = node.querySelector('#px-ship-note');
    const amt  = node.querySelector('#px-ship-amount');
    const bar  = node.querySelector('.px-ship-bar');

    const t = Math.max(0, total||0);
    const remaining = Math.max(0, goal - t);
    let pct = (t/goal)*100; if (pct<0) pct=0; if (pct>100) pct=100;

    if(fill) fill.style.width = pct + '%';
    if(bar)  bar.setAttribute('aria-valuenow', String(Math.min(t, goal)));

    if(remaining > 0){
      node.classList.remove('px-free');
      if(amt)  amt.textContent = 'Faltan ' + fmt(remaining);
      if(note) note.textContent = 'Agrega productos por ' + fmt(remaining) + ' para obtener envío gratis.';
    }else{
      node.classList.add('px-free');
      if(amt)  amt.textContent = '¡Ya tienes envío gratis!';
      if(note) note.textContent = 'Excelente, tu pedido califica para envío gratis.';
    }
  }

  async function refresh(){
    const node = document.getElementById('px-shipping-progress');
    if(!node) return;
    const total = await getTotal();
    if(total !== null) paint(node, total);
  }

  // Correr al cargar
  document.addEventListener('DOMContentLoaded', refresh);

  // Eventos comunes (ajusta si tu tema usa otros)
  ['cart:refresh','cart:updated','cart:change','ajaxProduct:added','cart:drawer:open','cart:open']
    .forEach(evt => document.addEventListener(evt, refresh));

  // Respaldo: observa cambios visuales dentro del drawer
  const mo = new MutationObserver(()=>{
    if(window.__pxShipTO) cancelAnimationFrame(window.__pxShipTO);
    window.__pxShipTO = requestAnimationFrame(refresh);
  });
  mo.observe(document.documentElement, {subtree:true, childList:true, characterData:true});
})();
